import React, { useRef, useState, useEffect } from 'react';
import { Title, Image, Modal, Text, Stack, Box, Center, Button } from '@mantine/core';
import OTPInput from 'otp-input-react';
import { showNotification } from '@mantine/notifications';
import dayjs from 'dayjs';
import Keyboard from 'react-simple-keyboard';
import { CircleX } from 'tabler-icons-react';
import PrintInvoice from '../PaymentStatus/invoice';
import tickMark from '../../image/tick-mark.png';
import { sendRequest } from '../../services/services';

const VerifyRefund = ({
  selectedVas,
  refundAmount,
  invoiceNumber,
  customerMobile,
  refundInfo,
  passId,
  profileData,
  dailCode,
}) => {
  const keyboard = useRef();
  const [otpInput, setOtpInput] = useState('');
  const [layoutName, setLayoutName] = useState('default');
  const [refundSuccess, setRefundSuccess] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [openInvoice, setOpenInvoice] = useState(false);

  const onInputChange = (e) => {
    setOtpInput(e);
  };

  const handleShift = () => {
    const newLayoutName = layoutName === 'default' ? 'shift' : 'default';
    setLayoutName(newLayoutName);
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  const onRefund = () => {
    const body = {
      refunded_amount: parseFloat(refundAmount, 10),
      vas: selectedVas,
      mobile: customerMobile,
      country_code_id: !dailCode ? 99 : dailCode,
      otp: otpInput,
      site_id: parseInt(refundInfo?.site_id, 10),
    };
    sendRequest(`/cashier/refund/${invoiceNumber}`, 'patch', body)
      .then(({ code, msg }) => {
        if (code === 20) {
          setRefundSuccess(true);
          setTimeout(() => {
            setRefundSuccess(false);
            setOpenInvoice(true);
          }, 2000);
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>{msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((value) => {
        if (value > 0) {
          return value - 1;
        }
        return value;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const generateOtp = () => {
    const body = {
      mobile: refundInfo?.mobile,
      country_code_id: refundInfo?.country_code_id,
    };
    sendRequest(`cashier/generate-otp`, 'post', body)
      .then(({ code }) => {
        setSeconds(60);
        if (code === 20) {
          showNotification({
            title: <Text weight={500}>Success full send OTP</Text>,
          });
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>User not registered!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };
  return (
    <Box>
      <Center>
        <Title order={5} className="no-printme">
          Enter the OTP to Process
        </Title>
      </Center>
      <Stack py="xl">
        <Center>
          <OTPInput
            OTPLength={4}
            inputStyles={{
              width: '40px',
              height: '40px',
              fontSize: '2.1rem',
              margin: '5px',
            }}
            id="otp"
            value={otpInput}
          />
        </Center>

        {seconds > 0 ? (
          <Text size="sm">Resend code in {dayjs.duration(seconds * 1000).format('mm:ss')}</Text>
        ) : (
          <Center>
            <Button
              style={{ width: '25%' }}
              disabled={seconds > 0}
              onClick={() => {
                generateOtp();
              }}
            >
              Send OTP
            </Button>
          </Center>
        )}
      </Stack>

      <Keyboard
        keyboardRef={(r) => {
          keyboard.current = r;
        }}
        layoutName={layoutName}
        onChange={onInputChange}
        onKeyPress={onKeyPress}
        maxLength={4}
        theme="hg-theme-default hg-layout-default myTheme enable-button"
        layout={{
          default: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
          shift: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
        }}
        display={{
          '{bksp}': '⌫',
        }}
      />
      <Stack py="xl">
        <Title order={4}>For OTP contact below Number</Title>
        <Title order={5}>Name: {refundInfo?.name}</Title>
        <Title order={5}>
          Phone: {refundInfo?.country_code?.dial_code} {refundInfo?.mobile}
        </Title>
      </Stack>
      <Center py="xl">
        <Button style={{ width: '40%', backgroundColor: '#01AA84' }} onClick={onRefund}>
          <Text>Submit</Text>
        </Button>
      </Center>

      <Modal opened={refundSuccess} centered onClose={() => setRefundSuccess(false)}>
        <Center>
          <Title order={3}>Refund Successful</Title>
        </Center>
        <Center py="xl">
          <Image src={tickMark} width={100} />
        </Center>
      </Modal>

      <Modal
        opened={openInvoice}
        onClose={() => setOpenInvoice(false)}
        centered
        withCloseButton={false}
      >
        <PrintInvoice
          invoiceDataId={invoiceNumber}
          passDataId={passId}
          profile={profileData}
          isRefund
        />
      </Modal>
    </Box>
  );
};

export default VerifyRefund;
